import { z } from "zod"
import { TimeFrameEnum, TimeFrameSchema } from "../../insights/timeFrame"
import { PaginationSchema } from "../../shared/pagination_dtos"

const EnabledKnowledgeFilterSchema = z
  .union([z.boolean(), z.enum(["true", "false"])])
  .transform((value) => value === true || value === "true")
  .default(true)

export const BackofficeKnowledgeFiltersSchema = z.object({
  questionPosition: z.enum(["all", "first", "second", "thirdPlus"]).default("all"),
  onlyShopify: EnabledKnowledgeFilterSchema,
  onlyClients: EnabledKnowledgeFilterSchema,
})

export const GetBackofficeKnowledgeMetricsSchema = BackofficeKnowledgeFiltersSchema.extend({
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.Last1Week),
  companyId: z.coerce.bigint().optional(),
})

export const GetBackofficeKnowledgeItemsSchema = GetBackofficeKnowledgeMetricsSchema.extend({
  companyId: z.coerce.bigint(),
})

export const GetBackofficeKnowledgeCategoryCompaniesSchema =
  GetBackofficeKnowledgeMetricsSchema.omit({ companyId: true }).extend({ category: z.string() })

export const GetBackofficeKnowledgeGapsSchema = PaginationSchema.extend({
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.Last1Week),
  companyId: z.coerce.bigint().optional(),
  category: z.string().min(1).optional(),
})

export const GetBackofficeUnansweredQuestionTopicsSchema = z.object({
  companyId: z.coerce.bigint().positive().optional(),
})

export const RecalculateBackofficeUnansweredQuestionTopicsSchema = z.object({}).strict()

export const BackofficeKnowledgeCompanyParamsSchema = z.object({
  companyId: z.coerce.bigint().positive(),
})

export const UpdateBackofficeKnowledgeCompanySchema = z
  .object({ shouldNotifyKnowledgeGapsOnSlack: z.boolean() })
  .strict()

export const GetBackofficeUnansweredTopicConversationsSchema = z.object({
  topicId: z.coerce.bigint().positive(),
})
